<template>
  <div id="export-to-pdf-modal">
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-title">Export to PDF</div>
        <div class="close-modal" v-if="!working" @click="setExportPDFMode(0)">
          <img src="@/assets/icons/ui/close-outline.png" alt="Close button" />
        </div>
      </div> 
      <div class="modal-body">
        <img src="@/assets/icons/ui/pdf-file.png" alt="pdf file icon" class="modal-file-icon">
        <div class="modal-status">
          <div class="modal-status-row">
            <div class="modal-status-title">
              {{ status }}
            </div>
            <div class="modal-status-progress">
              {{ progressText }}
            </div>
          </div>
          <div class="modal-progress-bar-container" v-if="showProgress">
            <div class="modal-progress-bar" :style="{ width: progressWidth }">

            </div>
          </div>
        </div>
      </div>
      <div class="modal-actions">
        <button type="btn" class="btn" v-if="ready" @click="downloadPDF">
          Download PDF
        </button>
      </div>
    </div>
    <div id="pages-container" style="position: fixed; left: 0; top: 0; opacity: 0.5; z-index: -1;">
      <div class="pages-converter">
        <template v-if="pages">
          <template v-for="(page, index) in pages">
            <article
              :id="'convert-page-' + index"
              class="project-page"
              :class="'template-' + templateName"
              :key="index + '-page'"
            >
              <component
                v-if="page"
                :readOnly="true"
                :is="page.type"
                :page="page"
                :pageId="index"
                :activePageItem="false"
                :onePageMode="false"
                :anonymousCrossOrigin="true"
                v-on="{
                  changePage,
                  openPreviewNewLockerProducts: emitOpenPreviewNewLockerProducts,
                  openSearchModal: emitOpenSearchModal,
                }"
              ></component>
            </article>
          </template>
          <slot name="hidding-modal"></slot>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
//const pageWidth = 595.28, pageHeight = 841.89
import Cover from "@/components/Projects/Playbooks/Cover/Cover.vue";
import Index from "@/components/Projects/Playbooks/Index/Index.vue";

import Hero from "@/components/Projects/Playbooks/Hero/Hero.vue";
import Designs from "@/components/Projects/Playbooks/Designs/Designs.vue";
import Stock from "@/components/Projects/Playbooks/Products/Stock.vue";
import Outfit from "@/components/Projects/Playbooks/Outfit/Outfit.vue";
import Extras from "@/components/Projects/Playbooks/Extras/Extras.vue";
import SnapsheetPage from "@/components/Projects/Snapsheets/SnapsheetPage.vue";
import BackCover from "@/components/Projects/Playbooks/BackCover/BackCover.vue";

import { mapActions, mapGetters, mapState } from 'vuex';

import { elementToSVG, inlineResources } from 'dom-to-svg'


export default {
  name: "ExportToPDFModal",

computed: {
    ...mapGetters("project", [
      "isPlaybook",
      "projectTitle",
      "color1",
      "color2",
      "color3",
    ]),

    ...mapGetters("playbook", ["branding"]),

    ...mapState("project", [
      "projectLogos",
      "spiritwearLogoId",
      "uniformsLogoId",
    ]),

    ...mapState(["endpoint", "auth"]),
    ...mapState("playbook", {
      playbookPages: (state) => state.pages,
      template: (state) => state.template,
    }),

    ...mapState(["settings"]),
    ...mapState("playbook", [
      "title",
      "sports",
    ]),

    ...mapState("snapsheet", {
      snapsheetPages: (state) => state.pages,

      templateName() {
        return this.template?.toLowerCase();
      },

      tableOfContents() {
        if (this.isPlaybook) {
          let pageNumber = 3;
          return this.sports?.map((sport) => {
            const row = {
              pageNumber,
              sport,
            };
            pageNumber += sport.layouts.length;
            return row;
          });
        }
        return []; //snaps
      },
    }),

    pages() {
      return this.isPlaybook ? this.playbookPages : this.snapsheetPages;
    },

    progressWidth() {
      return `${(
        (this.processedItems / this.totalAssets) *
        100
      ).toFixed(2)}%`;
    },
   
    progressText() {
      return `${parseInt(
        (this.processedItems / this.totalAssets) *
        100
      )}%`
    },
  },

  methods: {
    ...mapActions("project", ["setExportPDFMode"]),

    async init() {
      this.totalAssets = this.pages.length
      this.processedItems = 0
      this.showProgress = true
      this.status = "Preparing assets";

      this.svgs = []
      this.assets = []

      await this.prepareAssets()

      console.log('assets', this.assets)

      setTimeout(() => {
        this.convertPage()
      }, 1500 * this.pages.length )
    },

    async prepareAssets() {
      let localAssets = []/*, colorFamily = null, precoloredShadow = null, singleLayer = null, style = null, itemType = null, product = null*/

      for (let sportsIndex = 0; sportsIndex < this.sports.length; sportsIndex++) {
        const sport = this.sports[sportsIndex];

        //sport assets (heros from cover)
        localAssets = this.prepareSportFeaturedAssets(sport)

        //todo branding items 
        //

        //loop sport pages (layouts)
        /*for (let layoutsIndex = 0; layoutsIndex < sport.layouts.length; layoutsIndex++) {
          const page = sport.layouts[layoutsIndex];
          precoloredShadow = page.precolored_shadow
          colorFamily = page.is_chomagear ? 'chromagear_name' : 'stock_name'
          
          //loop page columns
          for (let columnsIndex = 0; columnsIndex < page.columnsIndex.length; columnsIndex++) {
            const column = page.columnsIndex[columnsIndex];

            //check all type of products
            //
            console.log(column, precoloredShadow, colorFamily)

            for (let itemsIndex = 0; itemsIndex < column.length; itemsIndex++) {
              const item = column[itemsIndex];
              
              singleLayer = item.single_layer
              style = item.style
              itemType = item.type
              product = item.product

              switch (itemType) {
                //todo parse html block images
                case 'product': {

                }
              }

            }
              
          }
        }*/
      }

      this.assets = localAssets
    },

    prepareSportFeaturedAssets(sport) {
      if (sport.featured_image) {
          //has hero, push images
          const colorFamily = sport.featured_chromagear ? 'chromagear_name' : 'stock_name'
          return [
            `${sport.featured_image}_base.png`,
            `${sport.featured_image}_c1_${this.color1[colorFamily]}.png`,
            `${sport.featured_image}_c2_${this.color2[colorFamily]}.png`,
            `${sport.featured_image}_c3_${this.color3[colorFamily]}.png`,
            `${sport.featured_image}_shadow.png`,
          ]
      }
      return []
    },

    async convertPage() {
      this.status = `Processing page #${ (this.processedItems * 1) + 1 }`;

      if (this.processedItems < this.pages.length) {
        const el = document.getElementById(`convert-page-${ this.processedItems }`)
        console.log(`Processing: #convert-page-${ this.processedItems }`)
        if (el) {
          
          // Capture specific element
          const svgDocument = elementToSVG(document.querySelector(`#convert-page-${ this.processedItems }`))

          // Inline external resources (fonts, images, etc) as data: URIs
          await inlineResources(svgDocument.documentElement)

          // Get SVG string
          const svgString = new XMLSerializer().serializeToString(svgDocument)

          //prepare assets
          //page assets like hero///////?


          this.svgs.push(
            svgString.replaceAll('http://localhost:8080', 'https://dealer-showroom-dev-projects-merge.vercel.app')
          )

          this.processedItems += 1
          this.convertPage()
        }
      }
      else {
        this.showProgress = false
        this.status = "Completed";

        /*const options = {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + process.env.VUE_APP_TEST_API_TOKEN || this.auth.apiToken
          }
        }*/
        const response = await axios.post(this.settings.endpoint + `convert-svg`, {
          svgs: [this.svgs[3]],
          images: this.assets
        })

        console.log(response)

      }
    },

    emitOpenSearchModal() {
      return false
    },

    emitOpenPreviewNewLockerProducts() {
      return false
    },

    changePage() {
      return false
    }

  },
  
  data() {
    return {
      processedItems: 0,
      totalAssets: 0,
      status: "",
      showProgress: false,
      showProgressInfo: false,
      working: false,
      ready: false,
      svgs: [],
      assets: []
  
    };
  },

  components: {
    Cover,
    Index,
    Hero,
    Designs,
    BackCover,
    Stock,
    Outfit,
    Extras,
    Snapsheet: SnapsheetPage,
  },
  
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
#export-to-pdf-modal {
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  z-index: 101;
  background: rgba(38, 38, 44, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;

  .modal-content {
    position: relative;
    width: 390px;
    display: flex;
    flex-direction: column;
    background: white;
    border-radius: 6px;

    .modal-header {
      align-items: center;
      
      .close-modal {
        position: absolute;
        right: 10px;
        top: 10px;
        cursor: pointer;
        background: #F9FAFA;
        border-radius: 6px;
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        padding: 4px;
        justify-content: center;
      }

      .modal-title {
        font-size: 1.3em;
        color: #26262C;
      }
      
    }

    .modal-body {
      display: flex;
      flex-direction: row;
      .modal-file-icon {
        width: 42px;
        height: 43px;
      }
      .modal-status {
        display: flex;
        flex-direction: column;
        width: 100%;
        .modal-status-row {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          font-size: .9em;
          margin: 0 1em;
          color: #6D7283;
        }
      }
    }

    .modal-progress-bar-container {
      position: relative;
      width: 300px;
      border-radius: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      background-color: #ECEDED;
      height: 6px;
      margin: 1em;
      
      .modal-progress-bar {
        position: absolute;
        background-color: #059C37;
        height: 100%;
        left: 0;
        z-index: 1;
        height: 6px;
      }
      .modal-progress-bar-info {
        min-height: 18px;
        z-index: 2;
      }
    }
    .modal-actions {
      margin: 1em;
      display: flex;
      justify-content: flex-end;
      button {
        display: flex;
        align-items: center;
        background: #4f4f53;
        color: white;
        padding: 0.5rem 1.5rem;
        text-transform: capitalize;
        height: 2.6rem;
      }
    }
  }
  #converter {
    display: none;
  }
}
</style>